import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const IMG = "https://images.unsplash.com/photo-1706629503603-e47c37722776?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.role === "admin" ? "/admin" : (u.business_id ? "/dashboard" : "/onboarding"));
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FAF8F5]">
      <div className="hidden lg:block relative">
        <img src={IMG} alt="Beauty clinic" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-stone-900/30" />
        <Link to="/" className="absolute top-8 left-8 flex items-center gap-2.5 text-white">
          <div className="h-9 w-9 rounded-xl bg-white/90 flex items-center justify-center text-stone-900 font-bold">G</div>
          <span className="font-bold text-lg">Get Booked In</span>
        </Link>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-10">
        <form onSubmit={submit} className="w-full max-w-sm animate-fade-up">
          <h1 className="font-extrabold text-3xl">Welcome back</h1>
          <p className="mt-2 text-stone-600 text-sm">Sign in to manage your salon.</p>
          {error && <div data-testid="login-error" className="mt-4 text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-lg px-3 py-2">{error}</div>}
          <div className="mt-6 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" data-testid="login-email-input" value={email}
                onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 h-11 rounded-lg" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" data-testid="login-password-input" value={password}
                onChange={(e) => setPassword(e.target.value)} required className="mt-1.5 h-11 rounded-lg" />
            </div>
          </div>
          <Button type="submit" data-testid="login-submit-button" disabled={loading}
            className="mt-6 w-full h-11 rounded-full bg-stone-900 hover:bg-stone-800">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
          <p className="mt-5 text-sm text-center text-stone-600">
            New here? <Link to="/register" className="font-semibold text-stone-900 underline">Start free trial</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
